import { VacationYtdAdjustmentHistory } from '@app/models/payroll/vacation-ytd-adjustment-history';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class PayPeriodNumberColumn extends Column {
    title = 'Pay Period';
    property = 'payPeriodNo';
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(vacationYtdAdjustmentHistory: VacationYtdAdjustmentHistory): string {
        return vacationYtdAdjustmentHistory.payPeriodNo ? 'P' + vacationYtdAdjustmentHistory.payPeriodNo : '-';
    }
}
